export const traders = {
  color: "green-c-traders",
  hex: "#A6DD27",
};
